const initHeaderSticky = () => {
	const header = document.querySelector('.site-header');

	if (!header) {
		return;
	}

	const handleScroll = () => {
		if (window.scrollY > 10) {
			header.classList.add('is-sticky');
		} else {
			header.classList.remove('is-sticky');
		}
	};

	handleScroll();

	window.addEventListener('scroll', handleScroll);

	const toggle = header.querySelector('.site-header__toggle');
	const nav = header.querySelector('.site-header__nav');
	if (!toggle || !nav) return;
	const mobile = window.matchMedia('(max-width: 991.98px)');

	const setOpen = (open, restoreFocus = false) => {
		const focusWasInside = nav.contains(document.activeElement);
		header.classList.toggle('is-menu-open', open);
		toggle.setAttribute('aria-expanded', String(open));
		toggle.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
		nav.inert = mobile.matches && !open;
		if (!open && mobile.matches && (restoreFocus || focusWasInside)) {
			toggle.focus({ preventScroll: true });
		}
	};

	setOpen(false);

	toggle.addEventListener('click', () => {
		if (mobile.matches) setOpen(toggle.getAttribute('aria-expanded') !== 'true');
	});
	nav.addEventListener('click', (event) => {
		if (event.target.closest('a')) setOpen(false);
	});
	document.addEventListener('keydown', (event) => {
		toggle.classList.remove('is-pointer-focus');
		if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
			event.preventDefault();
			setOpen(false, true);
		}
	});
	document.addEventListener('pointerdown', (event) => {
		if (toggle.contains(event.target)) toggle.classList.add('is-pointer-focus');
		if (!nav.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
	});
	mobile.addEventListener('change', () => setOpen(false));
};

export default initHeaderSticky;